/**
 * need to replace with serializer/deserializer from wagmi
 */

BigInt.prototype.toJSON = function () { return this.toString() }
global.BigInt.prototype.toJSON = function () { return this.toString() }
window.BigInt.prototype.toJSON = function () { return this.toString() }